module.exports = __webpack_public_path__ + "img/爱心单位.6c941713.png";